module.exports = "/_next/static/images/9d3942513266652c1d327b31e4a4f5de-value_proposal_lg.png";